export const InputsEnum = Object.freeze({
	TEXT: 'text',
	NUMBER: 'number',
	EMAIL: 'email',
	CHECKBOX: 'checkbox',
});
